/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-powerflow': {
    width: 16,
    height: 16,
    viewBox: '0 0 204 204',
    data: '<path pid="0" d="M112 68.875V92h74v43.125h18v50.5h-56v-50.5h18V112H38v23.125h18v50.5H0v-50.5h18V92h74V68.875H74v-50.5h56v50.5h-18z"/>'
  }
})
